export const formatScore = value => (value === null || value === undefined ? '-' : value.toString().replace('.', ','));

export const formatPercentage = value => (value === null || value === undefined ? '-' : `${value.toString().replace('.', ',')}%`);
